import {
  getModule,
  VuexModule,
  Mutation,
  Action,
  Module,
} from "vuex-module-decorators";
import store from "..";
import {
  IExternalVoucher,
  IExternalVouchersState,
} from "@/interfaces/store/IExternalVouchersState";
import BookingModule from "./booking";
import {
  AccountingState,
  PaymentMethods,
  TransactionTypes,
} from "@/types/db/accounting";
import { sum } from "lodash";
import {
  BookingStatus,
  IProductSlotState,
} from "@/types/db/product-slot-state";
import { IAccountingEntry } from "@/types/db/accounting-entry";

@Module({ dynamic: true, namespaced: true, store, name: "ExternalVouchers" })
class ExternalVouchersStoreModule
  extends VuexModule
  implements IExternalVouchersState
{
  public externalVouchers: IExternalVoucher[] = [];

  get getExternalVouchers(): IExternalVoucher[] {
    return this.externalVouchers || [];
  }

  // /**
  //  * Returns whether or not has cancelled tickets paid with external vouchers
  //  * Used to decide whether we Redeem or we Refund the external vouchers
  //  */
  // get hasCancelledTicketsPaidWithExternalVoucher(): boolean {
  //   const cancelledTickets: IProductSlotState[] | undefined =
  //     BookingModule.selectedBooking?.pssList.filter(
  //       (ps) => ps.bookingStatus === BookingStatus.Canceled
  //     );
  //   console.warn("cancelledTickets");
  //   console.warn(cancelledTickets);

  //   if (cancelledTickets && cancelledTickets.length) {
  //     // Lets check if these cancelled tickets are paid fully/partially with external vouchers
  //     const externalVoucherAccountings =
  //       BookingModule.selectedBooking?.accountings.filter(
  //         (acc) =>
  //           acc.state === AccountingState.Completed &&
  //           acc.transactionType === TransactionTypes.TRANSACTION_TYPE_PAYMENT &&
  //           (acc.isExternalVoucherService ||
  //             acc.paymentMethod === PaymentMethods.EXTERNAL_INCERT_VOUCHER)
  //       );
  //     const accEntries: IAccountingEntry[] = [];
  //     if (externalVoucherAccountings && externalVoucherAccountings.length) {
  //       externalVoucherAccountings.forEach((acc) => {
  //         acc.accountingEntriesList.forEach((entry) => accEntries.push(entry));
  //       });
  //     }
  //     console.warn("externalVoucherAccountings");
  //   console.warn(externalVoucherAccountings);

  //     const pssUuidsPaidWithExternalVouchers: string[] = accEntries.map(
  //       (accEntry) => String(accEntry.productSlotStateUuid)
  //     );
  //     console.warn("pssUuidsPaidWithExternalVouchers");
  //   console.warn(pssUuidsPaidWithExternalVouchers);
  //     cancelledTickets.forEach((ps) => {
  //       if (pssUuidsPaidWithExternalVouchers.includes(String(ps.uuid))) {
  //         // So there is at least one cancelled ticket paid with external vouchers
  //         return true;
  //       }
  //     });
  //   }

  //   return false;
  // }

  /**
   * Returns sum of accEntries values of all pending payment accountings of external vouchers
   */
  get externalVouchersPendingPaymentAccountingsSumToRedeem(): number {
    let sumPendingAccEntries = 0;
    const booking = BookingModule.selectedBooking;
    if (booking && booking.accountings && booking.accountings.length > 0) {
      booking.accountings.forEach((acc) => {
        if (
          !acc.id &&
          (acc.isExternalVoucherService ||
            acc.paymentMethod === PaymentMethods.EXTERNAL_INCERT_VOUCHER)
        ) {
          if (
            acc.transactionType === TransactionTypes.TRANSACTION_TYPE_PAYMENT &&
            acc.state === AccountingState.Pending &&
            !acc.refund
          ) {
            sumPendingAccEntries += sum(
              acc.accountingEntriesList.map((entry) => entry.value)
            );
          }
        }
      });
    }
    return sumPendingAccEntries;
  }

  @Mutation
  public addExternalVouchers(externalVoucher: IExternalVoucher) {
    this.externalVouchers.push(externalVoucher);
  }

  @Mutation
  public setExternalVouchers(externalVouchers: IExternalVoucher[]) {
    this.externalVouchers = externalVouchers;
  }

  @Mutation
  public removeExternalVouchersByOrderSession(orderSessionId: string) {
    if (this.externalVouchers && this.externalVouchers.length > 0) {
      this.externalVouchers = this.externalVouchers.filter(
        (voucherInfo) => voucherInfo.orderSessionId !== orderSessionId
      );
    }
  }

  @Mutation
  public updateExternalVoucher(updatedExternalVouchers: IExternalVoucher) {
    const oldVoucherInfo = this.externalVouchers.find(
      (v) =>
        v.voucherCode === updatedExternalVouchers.voucherCode &&
        v.orderSessionId === updatedExternalVouchers.orderSessionId
    );
    if (oldVoucherInfo) {
      oldVoucherInfo.currentSessionVoucherConsumption =
        updatedExternalVouchers.currentSessionVoucherConsumption;
    }
  }

  @Mutation
  public updateRemainingValue(updatedExternalVouchers: IExternalVoucher) {
    const oldVoucherInfo = this.externalVouchers.find(
      (v) =>
        v.voucherCode === updatedExternalVouchers.voucherCode &&
        v.orderSessionId === updatedExternalVouchers.orderSessionId
    );
    if (oldVoucherInfo) {
      oldVoucherInfo.originalRemainingValue =
        updatedExternalVouchers.originalRemainingValue;
    }
  }

  @Mutation
  public restore(moduleFields: IExternalVouchersState) {
    const { externalVouchers } = moduleFields;
    if (externalVouchers) {
      this.externalVouchers = externalVouchers;
    }
  }

  // @Action
  // public async fetchLocations() {
  //   if (!POSConfigModule.groupId) {
  //     throw new Error("Group id is not set for fetching locations");
  //   }

  //   const locations = await getGroupCashLocations(POSConfigModule.groupId);
  //   this.setLocations(locations);
  //   return locations;
  // }
}

const ExternalVouchersModule = getModule(ExternalVouchersStoreModule);
export default ExternalVouchersModule;
